
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import DeleteAllDialog from './DeleteAllDialog';

interface RequestsHeaderProps {
  onRefresh: () => void;
  onDeleteAll: () => void;
  hasRequests: boolean;
}

const RequestsHeader: React.FC<RequestsHeaderProps> = ({ onRefresh, onDeleteAll, hasRequests }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4 flex justify-between items-center">
      <h2 className="text-xl font-semibold">{t('interview.allRequests')}</h2>
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onRefresh}
          className="flex items-center gap-1"
        >
          <RefreshCw className="w-4 h-4" />
          {t('interview.refresh')}
        </Button>
        
        {hasRequests && (
          <DeleteAllDialog onDeleteSuccess={onDeleteAll} />
        )}
      </div>
    </div>
  );
};

export default RequestsHeader;
